const getters = {
  pointGroupListByOwnerProfileId: state => ownerProfileId => {
    const pointGroupList = state.pointGroupList.filter(pointGroup => {
      return pointGroup.ownerProfileId === ownerProfileId
    })
    return pointGroupList
  },
  alertModalIsShow: state => {
    return state.alertModal.isShow
  },
}

export default getters
